import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxEditorModule } from 'ngx-editor';
import { SemanticUiModule } from '@nstep-common/semantic-ui';
import { HttpClientModule } from '@angular/common/http';
import { QrCodeComponent } from 'ng-qrcode';

import {
	LoadingComponent,
	FieldComponent,
	TableViewComponent,
	TextAreaComponent,
	PathPipe,
	SearchTextPipe,
	AuthenticationComponent,
	ErrorMessageComponent,
	TrimDirective,
	DashPipe,
	AcccessHiderDirective,
	HasKeysPipe,
	ContextMenuComponent,
	MonthSelectorComponent,
	AuthService,
	BaseLayoutComponent,
	ReportViewComponent,
	ReportBaseComponent,
	StartCasePipe,
	SettingsService,
	LookupComponent
} from '@nstep-common/core';

@NgModule({
	declarations: [
		AcccessHiderDirective,
		LoadingComponent,
		FieldComponent,
		TableViewComponent,
		TextAreaComponent,
		PathPipe,
		SearchTextPipe,
		AuthenticationComponent,
		ErrorMessageComponent,
		TrimDirective,
		DashPipe,
		HasKeysPipe,
		ContextMenuComponent,
		MonthSelectorComponent,
		BaseLayoutComponent,
		ReportViewComponent,
		ReportBaseComponent,
		StartCasePipe,
		LookupComponent
	],
	imports: [
		HttpClientModule,
		NgxEditorModule,
		FormsModule,
		CommonModule,
		SemanticUiModule,
		FormsModule,
		QrCodeComponent
	],
	exports: [
		AcccessHiderDirective,
		LoadingComponent,
		FieldComponent,
		TableViewComponent,
		TextAreaComponent,
		PathPipe,
		SearchTextPipe,
		AuthenticationComponent,
		ErrorMessageComponent,
		TrimDirective,
		DashPipe,
		HasKeysPipe,
		ContextMenuComponent,
		MonthSelectorComponent,
		BaseLayoutComponent,
		ReportViewComponent,
		ReportBaseComponent,
		StartCasePipe,
		LookupComponent
	],
	providers: [
		DatePipe,
		AuthService,
		SettingsService
	]
})
export class CoreModule {
}